import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import { Dashboard } from '@/pages/Dashboard'
import { Upload } from '@/pages/Upload'
import { Analysis } from '@/pages/Analysis'
import { MemoViewer } from '@/pages/MemoViewer'
import { AmazonGrowthMemoViewer } from '@/pages/AmazonGrowthMemoViewer'
import { History } from '@/pages/History'
import { Customers } from '@/pages/Customers'
import { Reports } from '@/pages/Reports'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/analysis" element={<Analysis />} />
        <Route path="/analysis/:jobId" element={<Analysis />} />
        <Route path="/memo/:memoId" element={<MemoViewer />} />
        <Route path="/growth-memo/:memoId" element={<AmazonGrowthMemoViewer />} />
        <Route path="/memos" element={<Navigate to="/reports" replace />} />
        <Route path="/history" element={<History />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/reports" element={<Reports />} />
      </Routes>
    </Layout>
  )
}

export default App
